"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AlertDefaultProps = exports.Alert = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRouterDom = require("react-router-dom");

var _Icons = require("../foundation/Icons");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Alert = function Alert(props) {
  var _classNamesFn;

  var classNames = props.classNames,
      icon = props.icon,
      title = props.title,
      text = props.text,
      disableIcon = props.disableIcon,
      disableClose = props.disableClose,
      link = props.link,
      status = props.status,
      onClose = props.onClose,
      position = props.position,
      autoHideDuration = props.autoHideDuration,
      NewProps = _objectWithoutProperties(props, ["classNames", "icon", "title", "text", "disableIcon", "disableClose", "link", "status", "onClose", "position", "autoHideDuration"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      AddedAutoClose = _useState2[0],
      setAddedAutoClose = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      closing = _useState6[0],
      setClosing = _useState6[1];

  if (autoHideDuration < 0) {
    throw new Error('Hide Duration Invalid (negative)');
  }

  if (!open) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }

  var _onClose = function _onClose(event) {
    if (!disableClose) {
      // Closing gives a few seconds for a display transition to appear before element goes away.
      setClosing(true);

      var _autoCloseFunction = function _autoCloseFunction() {
        setOpen(false);
      };

      setTimeout(_autoCloseFunction, 2000);

      if (onClose) {
        onClose(event);
      }
    }
  }; // If requested, auto-close message box after a set interval.


  if (autoHideDuration > 0 && !AddedAutoClose && !disableClose) {
    setAddedAutoClose(true);

    var _autoHideFunction = function _autoHideFunction() {
      _onClose();
    };

    setTimeout(_autoHideFunction, autoHideDuration);
  } // settings to convert user passes in status to the icon used for that status


  var defaultIcons = new Map([['success', /*#__PURE__*/_react.default.createElement(_Icons.IcoCheckCircle, {
    key: 'Icon1'
  })], ['warning', /*#__PURE__*/_react.default.createElement(_Icons.IcoExclamationCircle, {
    key: 'Icon2'
  })], ['error', /*#__PURE__*/_react.default.createElement(_Icons.IcoBan, {
    key: 'Icon3'
  })], ['info', /*#__PURE__*/_react.default.createElement(_Icons.IcoInfoCircle, {
    key: 'Icon4'
  })]]);
  var alertClassName = (0, _classnames.default)((_classNamesFn = {
    'alert-component': true
  }, _defineProperty(_classNamesFn, "alert-component--status-".concat(status), true), _defineProperty(_classNamesFn, "alert-component--position-".concat(position), true), _defineProperty(_classNamesFn, 'alert-component--closed', closing), _classNamesFn), classNames);
  var alertIconClassName = (0, _classnames.default)({
    'alert-component__icon': true
  });
  var alertTextClassName = (0, _classnames.default)({
    'alert-component__text': true
  });
  var alertHyperlinkClassName = (0, _classnames.default)({
    'alert-component__hyperlink': true
  });
  var alertCloseClassName = (0, _classnames.default)({
    'alert-component__close': true
  }); // ADA compliant - allow an enter key to act like a click.

  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  }; // Do we display an icon, and if so, which one?


  var myIcon = typeof icon !== 'undefined' ? icon : defaultIcons.get(status);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: alertClassName
  }, NewProps), !disableIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: alertIconClassName
  }, myIcon), /*#__PURE__*/_react.default.createElement("div", {
    className: alertTextClassName
  }, title), link && text && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: link,
    className: alertHyperlinkClassName,
    role: "button",
    tabIndex: 0,
    onKeyDown: _handleKeyPress
  }, text), !link && text && /*#__PURE__*/_react.default.createElement("div", {
    className: alertHyperlinkClassName
  }, text), !disableClose && /*#__PURE__*/_react.default.createElement("button", {
    className: alertCloseClassName,
    onClick: _onClose,
    tabIndex: 0,
    "aria-label": "Close Alert"
  }, /*#__PURE__*/_react.default.createElement(_Icons.IcoTimes, {
    title: "Close Alert",
    fixedWidth: true
  }), /*#__PURE__*/_react.default.createElement(_Icons.IcoTimesLight, {
    title: "Close Alert",
    fixedWidth: true
  })));
};

exports.Alert = Alert;
Alert.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  icon: _propTypes.default.oneOfType([_propTypes.default.element]),
  link: _propTypes.default.string.isRequired,
  text: _propTypes.default.string.isRequired,
  disableIcon: _propTypes.default.bool.isRequired,
  disableClose: _propTypes.default.bool.isRequired,
  autoHideDuration: _propTypes.default.number.isRequired,
  position: _propTypes.default.oneOf(['none', 'top', 'bottom', 'center']).isRequired,
  status: _propTypes.default.oneOf(['info', 'success', 'warning', 'error']).isRequired,
  title: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func
};
var AlertDefaultProps = {
  classNames: {},
  icon: undefined,
  // use default icon for status type
  disableIcon: false,
  disableClose: false,
  link: '',
  text: '',
  autoHideDuration: 0,
  // don't auto-hide
  position: 'none'
};
exports.AlertDefaultProps = AlertDefaultProps;
Alert.defaultProps = AlertDefaultProps;
var _default = Alert;
exports.default = _default;